import app from 'flarum/forum/app';
import { formatMoney } from '../../common/utils/currency';
import { safeHref } from '../../common/utils/safeHref';
import MpProductEmbedModal from './MpProductEmbedModal';
function resolveType(meta) {
  if (meta.is_pool) return {
    key: 'pool',
    icon: 'fas fa-ticket-alt',
    labelKey: 'pool'
  };
  if (meta.is_composer) return {
    key: 'composer',
    icon: 'fab fa-php',
    labelKey: 'composer'
  };
  if (meta.type === 'service') return {
    key: 'service',
    icon: 'fas fa-concierge-bell',
    labelKey: 'service'
  };
  if (meta.type === 'physical') return {
    key: 'physical',
    icon: 'fas fa-box',
    labelKey: 'physical'
  };
  return {
    key: 'digital',
    icon: 'fas fa-cloud-download-alt',
    labelKey: 'digital'
  };
}
function tt(k) {
  return app.translator.trans('ramon-marketplace.forum.embed.' + k);
}

/**
 * Card embed renderizado no lugar de um link de produto colado num post.
 * Recebe os metadados pré-buscados (cache feito pelo embedScanner).
 *
 * Click abre o modal de detalhes (em vez de nova aba). Ctrl/middle-click
 * preservam o comportamento padrão (abrir nova aba).
 */
export default class MpProductEmbed {
  oninit(vnode) {
    this.attrs = vnode.attrs;
  }
  view() {
    const meta = this.attrs.meta;
    if (!meta.found) return null;
    const isRecurring = meta.billing_cycle && meta.billing_cycle !== 'one_time';
    const cycleLabel = meta.billing_cycle === 'yearly' ? tt('per_year') : tt('per_month');
    const t = resolveType(meta);
    const typeLabel = tt('types.' + t.labelKey);
    const isFree = meta.is_open_source || (meta.price ?? 0) === 0;
    return m("a", {
      href: safeHref(meta.url),
      className: `MpEmbed MpEmbed--${t.key}`,
      target: "_blank",
      rel: "noopener",
      title: meta.name,
      onclick: e => {
        // Ctrl/Cmd/middle-click → comportamento padrão (nova aba)
        if (e.ctrlKey || e.metaKey || e.shiftKey || e.button === 1) return;
        e.preventDefault();
        app.modal.show(MpProductEmbedModal, {
          meta
        });
      }
    }, m("div", {
      className: "MpEmbed-thumb"
    }, meta.image_url ? m("img", {
      src: safeHref(meta.image_url),
      alt: "",
      loading: "lazy"
    }) : m("i", {
      className: t.icon
    }), m("span", {
      className: "MpEmbed-typeBadge",
      title: typeLabel
    }, m("i", {
      className: t.icon
    }))), m("div", {
      className: "MpEmbed-body"
    }, m("div", {
      className: "MpEmbed-meta"
    }, m("span", {
      className: "MpEmbed-type"
    }, typeLabel), meta.category && m('[', null, m("span", {
      className: "MpEmbed-dot"
    }, "\xB7"), m("span", {
      className: "MpEmbed-cat"
    }, meta.category)), meta.is_open_source && m("span", {
      className: "MpEmbed-tag MpEmbed-tag--free"
    }, m("i", {
      className: "fas fa-code-branch"
    }), " ", tt('oss'))), m("div", {
      className: "MpEmbed-name"
    }, meta.name), meta.description && m("p", {
      className: "MpEmbed-desc"
    }, meta.description), m("div", {
      className: "MpEmbed-foot"
    }, m("span", {
      className: "MpEmbed-price"
    }, isFree ? m("span", {
      className: "MpEmbed-free"
    }, tt('free')) : meta.dual_billing && meta.price_yearly ? m('[', null, m("strong", null, formatMoney(meta.price ?? 0)), m("small", null, tt('per_month')), m("span", {
      className: "MpEmbed-dot"
    }, "\xB7"), m("strong", null, formatMoney(meta.price_yearly)), m("small", null, tt('per_year'))) : m('[', null, m("strong", null, formatMoney(meta.price ?? 0)), isRecurring && m("small", null, cycleLabel))), !!(meta.reviews_count && meta.rating) && m("span", {
      className: "MpEmbed-rating",
      title: `${meta.rating}/5 (${meta.reviews_count})`
    }, m("i", {
      className: "fas fa-star"
    }), " ", meta.rating.toFixed(1)))));
  }
}
flarum.reg.add('ramon-marketplace', 'forum/components/MpProductEmbed', MpProductEmbed);